module.exports = __webpack_public_path__ + "static/media/banner_web.a8cd1bc5.png";